import AemButton from '@/components/Aem/AemButton';
import AppImage from '@/components/Image/AppImage';
import RemoteImage from '@/components/Image/RemoteImage';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import {formatBadgeImageUrl, getAchievedBadgeImage} from '@/services/loyalty/badgeUtils';
import * as loyaltyUtils from '@/services/loyalty/loyaltyUtils';

const BADGE_ITEM_IMAGE_SIZE = 400;

const BadgeItem = ({badge, backgroundImage, learnMoreButton, externalLink}) => {
    const badgeImage = getAchievedBadgeImage(badge);
    const formattedBadgeImageUrl = formatBadgeImageUrl(
        badgeImage?.imageURL,
        BADGE_ITEM_IMAGE_SIZE,
        BADGE_ITEM_IMAGE_SIZE
    );
    const {badgeId, journeyId, journeyName} = badge;
    const {redirectToExternalLink: redirect} = useConfigExternalLink({...externalLink, ssoParams: {journeyId}});

    const handleBadgeClick = (e) => {
        e.stopPropagation();
        loyaltyUtils.trackLoyaltyClick(badgeId);
        redirect?.();
    };

    if (!badge) {
        return null;
    }

    return (
        <div
            className='relative isolate h-[220px] cursor-pointer overflow-hidden rounded-xl bg-primary-dark px-4 py-1 text-center md:h-[328px] ml:cursor-default'
            onClick={handleBadgeClick}
            role='button'
            tabIndex={0}
            aria-label={journeyName}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleBadgeClick(e);
                }
            }}
        >
            <RemoteImage className='absolute left-0 top-0 h-full w-full' imageMedia={backgroundImage} />
            <div className='relative z-10 flex flex-col items-center'>
                <AppImage
                    src={formattedBadgeImageUrl}
                    alt={badge?.journeyName}
                    className='h-auto w-[130px] md:w-[200px]'
                    decode={false}
                />
                <h3 className='mt-3 text-16 font-normal text-romance md:mt-0 md:font-bold md:tracking-02'>
                    {badge?.journeyName}
                </h3>
                {externalLink && (
                    <AemButton
                        className='mt-6 hidden w-auto ml:block'
                        secondary
                        darkV2
                        onClick={handleBadgeClick}
                        {...learnMoreButton}
                    />
                )}
            </div>
        </div>
    );
};

export default BadgeItem;
